import React from 'react';
import { NodeParameterRemoveButton } from '@flow/buttons/NodeParameterRemoveButton';
import { AgentFlowParameterWrapper, AgentFlowParameterLabelWrapper } from '@flow/styles';
import { Body5, Container } from '@ui';
import { TransparentFlatButton } from '@ui/buttons';
import styled from 'styled-components';
import { useDoc } from '@hooks/features/useDoc';

const DocItemWrapper = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const DocIdToFilenameDisplay = ({ docId }) => {
  const doc = useDoc(docId);
  if (!doc) {
    return null;
  }
  return (
    <DocItemWrapper>
      <Body5>{doc.filename}</Body5>
    </DocItemWrapper>
  );
};

const DocSelectionItem = ({ doc }) => {
  if (!doc) {
    return <DocIdToFilenameDisplay docId={doc.id} />;
  }
  return (
    <DocItemWrapper>
      <Body5>{doc.filename}</Body5>
    </DocItemWrapper>
  );
};

export const DocSelectionParameter = ({
  nodeData,
  data,
  value,
  onRemove,
  onChange,
  openDocSelectionModal,
  updateNodeData,
  parentNodeId,
}) => {
  const { keyName, label } = data;

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const selectedDocs = nodeData.selectedDocs;
    setItems(selectedDocs || []);

    if (!nodeData.selectedDocs) {
      updateNodeData(parentNodeId, { selectedDocs: [] });
    }
  }, [nodeData.selectedDocs]);

  React.useEffect(() => {
    const syncItems = () => {
      if (Array.isArray(value)) {
        setItems(value);
      } else {
        setItems([value]);
      }
    };
    syncItems();
  }, []);

  React.useEffect(() => {
    onChange(
      keyName,
      items.filter((el) => el !== '').map((d) => d.id)
    );
  }, [items]);

  const handleAddItem = () => {
    openDocSelectionModal();
  };

  const handleRemoveClick = () => {
    onRemove(keyName);
  };

  const handleRemoveItemClick = (i) => {
    setItems((prevItems) => {
      const copy = [...prevItems];
      return copy.filter((el, elIndex) => elIndex !== i);
    });
  };

  return (
    <AgentFlowParameterWrapper>
      <Container fullWidth>
        <Container row verticallyCenter spaceBetween fullWidth>
          <Container row verticallyCenter>
            <AgentFlowParameterLabelWrapper>
              <Body5>{label}:</Body5>
            </AgentFlowParameterLabelWrapper>
            <div className="read-only-hide">
              <TransparentFlatButton onClick={handleAddItem}>Add List Item</TransparentFlatButton>
            </div>
          </Container>

          <NodeParameterRemoveButton onClick={handleRemoveClick} />
        </Container>
        <ul>
          {items.map((item, index) => (
            <li key={index}>
              <Container fullWidth row verticallyCenter>
                <DocSelectionItem doc={item} />
                <NodeParameterRemoveButton onClick={() => handleRemoveItemClick(index)} />
              </Container>
            </li>
          ))}
        </ul>
      </Container>
    </AgentFlowParameterWrapper>
  );
};
